import { SelMessage } from "@selector/shared/components";
import type { FC, ReactNode } from "react";
import { Card, type GridCard } from "widgets";

import type { Pathway } from "@/graphql.ts";

import { NoteTile } from "../../core/tiles/index.js";

export interface IPathwayListCardProps extends GridCard {
  pathways: Pathway[];
  ignoreIfEmpty?: boolean;
  title?: string;
  showSource?: boolean;
}

const MetabolicPathwayListCard: FC<IPathwayListCardProps> = (props) => {
  const pathways: Pathway[] = props.pathways;
  if (props.ignoreIfEmpty && (!pathways || pathways.length === 0)) {
    return null;
  }

  let elements: ReactNode = <SelMessage id={"noContent.pathways"} />;

  if (pathways && pathways.length > 0) {
    elements = pathways.map((pathway: Pathway, index) => {
      return (
        <NoteTile title={pathway.name} key={`pathway-card-elem-${index}`}>
          {pathway.description}
        </NoteTile>
      );
    });
  }

  return (
    <Card
      title={props.title ?? "Pathways"}
      tag={{ label: String(pathways ? pathways.length : 0) }}
      shrinkable={props.pathways.length > 7}
    >
      {elements}
    </Card>
  );
};

export { MetabolicPathwayListCard };
